import styled from 'styled-components'

const Wrapper = styled.span`
  .ant-select-dropdown {
    width: max-content !important;
    max-width: 300px !important;
  }

  .select-dropdown {
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
  }

  .ant-checkbox-wrapper {
    line-height: 32px;
    display: flex;

    .ant-checkbox {
      border-radius: 2px !important;
      align-self: flex-start !important;
      margin-top: 8px;
      margin-left: 8px;
    }
  }

  .ant-select-single.ant-select-open .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88);
  }

  .ant-select-item-option-content {
    white-space: inherit;
    word-wrap: break-word;
  }

  .selected-item {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    background-color: #e6f4ff;
  }
`

export { Wrapper }
